export default "__VITE_ASSET__pBkz1gbV__";